import React, {Component} from 'react';

class GalleryContainer extends Component {
    render() {
        return (
            <div className="container text-center">
                <h1 className="display-4">Gallery</h1>
                <p>The gallery will be added as soon as possible.</p>
                <p className="text-muted">Thank you for visiting.</p>
            </div>
        );
    }
}

export default GalleryContainer;